import { Component, OnInit, COMPILER_OPTIONS } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SocketclientService } from '../socketclient.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomerToken } from '../Models/customertoken.modal';

@Component({
  selector: 'app-customertoken',
  templateUrl: './customertoken.component.html',
  styleUrls: ['./customertoken.component.css']
})
export class CustomertokenComponent implements OnInit {

  data: CustomerToken;
  storeId: any;
  cookieValue: any;
  stores: any;
  languages: any;
  services:any;

  // Start --> Variables for value of controls
  address: number;
  asccode: string;
  break_end_time: string;
  break_start_time: string;
  currenttokens: string;
  email: string;
  end_time: string;
  is_break_available: number;
  name: string;
  phone1: string;
  phone2: string;
  start_time: string;
  // End

  constructor(private router: Router, private rout: ActivatedRoute, private sw: SocketclientService, private cookieService: CookieService) {
    this.sw.WebSocketMessage().subscribe(data => {
      this.onReceive(data);
    });

    this.sw.WebSocketConnected().subscribe(() => {
      this.onOpen();
    });

    if(this.rout.snapshot.paramMap.has('storeId')) {
      this.storeId = this.rout.snapshot.paramMap.get('storeId');
    }
    if(this.rout.snapshot.paramMap.has('asccode')) {
      this.asccode = this.rout.snapshot.paramMap.get('asccode');
    }

    this.cookieValue = JSON.parse(this.cookieService.get("login"));

    // Start --> Call Web Scocket Request
    if (this.cookieValue) {
      var str = {"doctorid":this.storeId,"usertype":"doctordetails"};
      this.sw.send(JSON.stringify(str));

      var str1 = { "company_id": this.storeId, "asccode": this.asccode, "usertype": "get_languages" };
      this.sw.send(JSON.stringify(str1));

      var str2 = { "asccode": this.asccode, "usertype": "get_services", "lang": "en" };
      this.sw.send(JSON.stringify(str2));
    } else {
    }
    // End
   }

  ngOnInit() {
    this.data = new CustomerToken();
  }

  onReceive(Data) {
    if (Data) {
      const msg = JSON.parse(Data);
      if (msg.usertype == "doctordetails") {
        if (msg.isSuccess) {
          this.stores = msg.data;
          this.data = this.stores;

          // Start -->Set Values For Contact Us Detail
          this.name = this.data.name;
          this.address = this.data.address;
          this.phone1 = this.data.phone1;
          this.phone2 = this.data.phone2;
          this.email = this.data.email;
          this.start_time = this.data.start_time;
          this.end_time = this.data.end_time;
          this.break_start_time = (this.data.is_break_available == 1 ? this.data.break_start_time : "-");
          this.break_end_time = (this.data.is_break_available == 1 ? this.data.break_end_time : "-");
          // End
        }
      }

      if (msg.usertype == "get_languages") {
        if (msg.isSuccess) {
          this.languages = msg.data;

          this.data.langcode = this.languages[0].code;

          // if (this.data.langcode == "en") {
          //   var str2 = { "asccode": this.asccode, "usertype": "get_services", "lang": this.data.langcode };
          //   this.sw.send(JSON.stringify(str2));
          // }
        }
      }

      if (msg.usertype == "get_services") {
        if (msg.isSuccess) {
          this.services = msg.data;
        }
      }
    }
    else {
      this.stores = null;
    }
  }

  onOpen(){
    console.log("Wesocket Connected");
  }

  callService(langCode) {
    var str2 = { "asccode": this.asccode, "usertype": "get_services", "lang": langCode };
    this.sw.send(JSON.stringify(str2));
  }

  getToken(abb,priority,lang) {
    var str2 = {"asccode":this.data.asccode,"usertype":"token","mobileno":this.data.phone2,"type":abb,"lang":lang,"priority":priority}
    this.sw.send(JSON.stringify(str2));
  }

  callTab(divName) {
    if (divName == 'divGenerate') {
      document.getElementById("divGenerate").style.display = "block";
      document.getElementById("divTokenInfo").style.display = "none";
      document.getElementById("divContact").style.display = "none";
    }
    if (divName == 'divTokenInfo') {
      document.getElementById("divGenerate").style.display = "none";
      document.getElementById("divTokenInfo").style.display = "block";
      document.getElementById("divContact").style.display = "none";
    }
    if (divName == 'divContact') {
      document.getElementById("divGenerate").style.display = "none";
      document.getElementById("divTokenInfo").style.display = "none";
      document.getElementById("divContact").style.display = "block";
    }
  }
}
